/**
 * 將經文中的強字號標記轉換為可點擊編號標記
 * 格式：
 *   主要強字號：「...字詞<WH12345>」→ 「...字詞 <H12345>」
 *   詞性代碼：「<WTH8804>」→ 「<8804>」（可點擊，獨立查詢詞性信息）
 */
export function parseStrongsMarkup(text: string, _showMorphology: boolean): string {
  if (!text) return ''

  // 移除虛詞強字號（被大括號包住的）
  let result = text.replace(/\{<W(A|T)?[HG]\d+>\}/g, '')

  let output = ''
  let lastIndex = 0

  // 查找所有標記
  const markupRegex = /<W(A|T)?([HG])(\d+)>/g
  let match

  while ((match = markupRegex.exec(result)) !== null) {
    const markupStart = match.index
    const textBefore = result.substring(lastIndex, markupStart)
    const testament = match[2] === 'H' ? 'OT' : 'NT'
    const number = match[3]
    const isAOrT = match[1]

    // 添加前面的文本
    output += textBefore

    if (isAOrT === 'T') {
      // 詞性代碼 - 獨立的可點擊元素，查詢詞性代碼本身
      output += `<span class="morph-code" data-code="${number}">&lt;${number}&gt;</span>`
    } else if (isAOrT !== 'T') {
      // 主要強字號 - 插入可點擊的編號標記
      output += ` <span class="strongs-ref" data-strongs="${number}" data-testament="${testament}">${testament === 'OT' ? 'H' : 'G'}${number}</span>`
    }

    lastIndex = markupStart + match[0].length
  }

  // 添加剩餘的文本
  output += result.substring(lastIndex)

  return output
}
